import { Play, Pause, RotateCcw, Volume2, RefreshCw, Loader2 } from "lucide-react";

const fmt = (s) => {
  if (!s || !isFinite(s)) return "0:00";
  return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
};

export default function AudioBar({ audio, hasAudio, estSec, t }) {
  if (!hasAudio || audio.error) {
    return (
      <div className="flex items-center gap-3 rounded-xl bg-[#F5F0E6] px-3 py-2.5 text-xs text-[#5C6B73]" data-testid="audio-unavailable">
        <Volume2 className="h-4 w-4 shrink-0" />
        <span className="flex-1">{t("Audio unavailable — continue reading")}</span>
        {hasAudio && <button onClick={audio.retry} className="inline-flex items-center gap-1 font-bold text-[#179B80]" data-testid="audio-retry-btn"><RefreshCw className="h-3.5 w-3.5" />{t("Retry audio")}</button>}
      </div>
    );
  }
  const dur = audio.dur || estSec || 0;
  const pct = dur ? Math.min(100, (audio.time / dur) * 100) : 0;
  const onSeek = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    audio.seek((e.clientX - r.left) / r.width);
  };
  return (
    <div className="flex items-center gap-2.5 rounded-xl bg-white border border-[#EADEC9] pl-1.5 pr-3 py-1.5" data-testid="audio-player">
      <button onClick={audio.toggle} className="h-10 w-10 shrink-0 rounded-full bg-[#1DB99A] text-white flex items-center justify-center active:scale-95 transition-transform" aria-label="Play or pause" data-testid="audio-play-pause-btn">
        {audio.loading && audio.playing ? <Loader2 className="h-4 w-4 animate-spin" /> : audio.playing ? <Pause className="h-4 w-4" fill="currentColor" /> : <Play className="h-4 w-4 ml-0.5" fill="currentColor" />}
      </button>
      <span className="text-[11px] font-semibold tabular-nums text-[#5C6B73] w-8" data-testid="audio-current-time">{fmt(audio.time)}</span>
      <div className="flex-1 h-6 flex items-center cursor-pointer" onClick={onSeek} data-testid="audio-progress">
        <div className="h-1.5 w-full rounded-full bg-[#EADEC9] overflow-hidden"><div className="h-full bg-[#1DB99A] transition-[width] duration-200" style={{ width: `${pct}%` }} /></div>
      </div>
      <span className="text-[11px] font-semibold tabular-nums text-[#5C6B73] w-8 text-right" data-testid="audio-duration">{fmt(dur)}</span>
      <button onClick={audio.replay} className="h-8 w-8 shrink-0 rounded-full flex items-center justify-center text-[#5C6B73] hover:bg-[#F5F0E6]" aria-label="Replay" data-testid="audio-replay-btn"><RotateCcw className="h-4 w-4" /></button>
    </div>
  );
}
